import * as Yup from 'yup'

import { HomeIssueType } from '@/types/HomeIssue'

export const formSchema = Yup.object().shape({
  homeInventoryItemId: Yup.number()
    .nullable()
    .when(['type'], {
      is: (type: HomeIssueType) => type === HomeIssueType.DAMAGE || type === HomeIssueType.REPLACEMENT_NEEDED,
      then: () =>
        Yup.number().required('Damage and Replacement Needed Issues require an associated Home Inventory Item.'),
    }),
  homeIssueId: Yup.number().required('A Home Issue ID is required to update a Home Issue.'),
  homeLocationId: Yup.number().required('A Home Location is required to submit a Home Issue.'),
  notes: Yup.string(),
  type: Yup.mixed<HomeIssueType>()
    .oneOf(Object.values(HomeIssueType))
    .required('An Issue Type is required to submit a Home Issue.'),
})

export interface FormValuesType {
  attachments?: []
  homeInventoryItemId?: number | undefined
  homeIssueId: number
  homeLocationId?: number
  notes?: string
  type?: HomeIssueType
}
